import { render, staticRenderFns } from "./LeadSettingSection.vue?vue&type=template&id=682fccb2"
import script from "./LeadSettingSection.vue?vue&type=script&lang=js"
export * from "./LeadSettingSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports